import React from "react";
import {ReviewSortLabel, ReviewSortSection} from "./Styled";
import PropTypes from "prop-types";

const ReviewSort = (props) => {
    return (
        <ReviewSortSection sortTypeBadge={props.sortTypeBadge}>
            <label>{props.sortTypeBadge ? "Sort by" : "Sort By:"}</label>
            <ReviewSortLabel
                className={props.sortType === "recency" ? "active arrowPos" : ""}
                onClick={() => props.doSort("recency")}
                sortTypeBadge={props.sortTypeBadge}
            >
                <span>Recency </span>
            </ReviewSortLabel>
            <ReviewSortLabel
                className={props.sortType === "highRating" ? "active" : ""}
                onClick={() => props.doSort("highRating")}
                sortTypeBadge={props.sortTypeBadge}
            >
                <span>Highest Rating</span>
            </ReviewSortLabel>
            <ReviewSortLabel
                className={props.sortType === "lowRating" ? "active" : ""}
                onClick={() => props.doSort("lowRating")}
                sortTypeBadge={props.sortTypeBadge}
            >
                <span>Lowest Rating</span>
            </ReviewSortLabel>
        </ReviewSortSection>
    );
};

ReviewSort.propTypes = {
    doSort: PropTypes.func,
    sortType: PropTypes.string,
    sortTypeBadge: PropTypes.bool,
};
export default ReviewSort;
